import { types } from './actions';

const initialState = {
  areGlobalExpediteOptionsSaving: false,
  globalExpediteOptions: null,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.FETCH_GLOBAL_EXPEDITE_OPTIONS_ERROR:
      return {
        ...state,
        areGlobalExpediteOptionsSaving: false,
      };
    case types.FETCH_GLOBAL_EXPEDITE_OPTIONS_SUCCESS:
      return {
        ...state,
        areGlobalExpediteOptionsSaving: false,
        globalExpediteOptions: payload.globalExpediteOptions,
      };
    case types.UPDATE_GLOBAL_EXPEDITE_OPTIONS_REQUEST:
      return {
        ...state,
        areGlobalExpediteOptionsSaving: true,
      };
    case types.UPDATE_GLOBAL_EXPEDITE_OPTIONS_SUCCESS:
      return {
        ...state,
        areGlobalExpediteOptionsSaving: false,
        globalExpediteOptions: payload.globalExpediteOptions,
      };
    case types.UPDATE_GLOBAL_EXPEDITE_OPTIONS_ERROR:
      return {
        ...state,
        areGlobalExpediteOptionsSaving: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.digitalQuote.expedites;

export const areGlobalExpediteOptionsSaving = (state) =>
  getScope(state).areGlobalExpediteOptionsSaving;

export const getGlobalExpediteOptions = (state) => {
  const expedites = getScope(state).globalExpediteOptions;
  for (let i = 0; i <= 2 - expedites.length; i++)
    expedites.push({ id: null, daysFaster: null, markup: null });
  return expedites;
};
